export default {
  faqTitle: 'Generali Sigorta Hakkında Merak Edilen Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  products: {
    title: 'Generali Sigorta Ürünleri',
    buttons: [
      {
        id: 1,
        title: 'TRAFİK SİGORTASI',
        class: 'company--btn--icons fas fa-car fa-2x mr-2',
        path: 'GeneraliSigortaCompulsoryTraffic'
      },
      {
        id: 2,
        title: 'KASKO SİGORTASI',
        class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
        path: 'GeneraliSigortaMotorInsurance'
      },
      {
        id: 3,
        title: 'DASK SİGORTA',
        class: 'company--btn--icons fas fa-laptop fa-2x mr-2',
        path: 'GeneraliSigortaDaskInsurance'
      },
      {
        id: 4,
        title: 'KONUT SİGORTASI',
        class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
        path: 'GeneraliSigortaHomeInsurance'
      },
      {
        id: 5,
        title: 'İŞYERİ SİGORTASI',
        class: 'company--btn--icons fas fa-building fa-2x mr-2',
        path: 'GeneraliSigortaCompanyInsurance'
      },
      {
        id: 6,
        title: 'FERDİ KAZA SİGORTASI',
        class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
        path: 'GeneraliSigortaPersonalAccident'
      },
      {
        id: 7,
        title: 'NAKLİYAT SİGORTASI',
        class: 'company--btn--icons fas fa-dolly-flatbed fa-2x mr-2',
        path: 'GeneraliSigortaTransportation'
      },
      {
        id: 8,
        title: 'SEYAHAT SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
        path: 'GeneraliSigortaTravelInsurance'
      }
    ]
  },
  introContent: {
    title: 'Generali Sigorta Hakkında',
    content: [
      {
        paragraph:
          'Generali Sigorta 1831 senesinde İtalya’da kurulmuştur. Aynı zamanda Türkiye’nin ilk sigorta şirketi olan Generali Sigorta, İstanbul’da 1863 yılında ilk acentesi kurulup sigortacılık hizmetlerine başlamıştır.'
      },
      {
        paragraph:
          'Türkiye’de Generali Sigorta Anonim Şirketi olarak 1989 yılında kurulup yerelleşme adımında büyük faaliyet başlamıştır. Avrupa‘nın en güçlü 3 sigorta şirketinden 1’i olan Generali Sigorta, Türkiye’de 500 üzerindeki acentesi ile detaylı hizmet ağına sahiptir. '
      },
      {
        paragraph:
          'Müşteri hizmetlerini karşılamak amacı ile kurulan çağrı merkezi ile ülkemizdeki her bölgeye hızlı hizmet vermektedir. '
      },
      {
        paragraph:
          'Generali Sigorta ekonomik sorumluluk haricinde, değerleri ile ön plana çıkmaktadır. 2006 senesinden itibaren, Avrupa Sosyal Hakları Sözleşmesini baz alarak bu yönde ilerlemelerine devam etmektedir. Sigorta şirketi iş önceliği ve müşteri davranışlarını dikkate alarak, kurumsal sorumluluk stratejisi ile hizmet vermektedir.'
      }
    ]
  },
  questions: [
    {
      title: 'Generali Sigorta Ürün Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Generali Sigorta ürünlerinden faydalanmak isteyen müşterilerimiz alokasko.com sayfamızdan en kapsamlı teminat ve en uygun teklifleri alabilir.',
          subList: null
        },
        {
          paragraph:
            'Generali Sigorta Alokasko’nun anlaşmalı olduğu sigorta şirketlerindendir. Şirketimiz bünyesinde size özel teklif verebileceğimiz bazı sigorta ürünleri;',
          subList: [
            'Trafik Sigortası',
            'Araç Kasko Sigortası',
            'DASK (Zorunlu Deprem Sigortası)',
            'Konut Sigortası',
            'İşyeri Sigortası',
            'Ferdi Kaza Sigortası',
            'Nakliyat Sigortası',
            'Seyahat Sağlık Sigortası'
          ]
        },
        {
          paragraph:
            'Tüm bu branşlarda ihtiyaç duyduğunuz poliçelere sahip olabilirsiniz. Generali Sigorta ile özel anlaşmalarımız gereği, hiçbir yerde bulamayacağınız çok uygun rakamlarla internete özel poliçenizi yaptırabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Zorunlu Trafik Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Generali Sigorta Zorunlu Trafik Sigortası ile, trafikte yapmış olduğunuz kazalarda kusurlu olmanız durumunda üçüncü şahısların zararlarını teminat dahilinde Generali güvencesine alabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Teminatlar her yıl Devlet Hazine Müsteşarlığı tarafından belirlenmektedir. ',
          subList: null
        },
        {
          paragraph:
            'Generali Sigorta müşterilerinin memnuniyeti ve acil durumlarda destek olabilmek için, trafik sigortalarında ek olarak kaza durumunda yol yardım hizmetini poliçeye eklemektedir. Ve poliçelerdeki bu hizmetlerden faydalanmak istediğiniz anda Alokasko.com ve Generali Sigorta Müşteri Hizmetlerini aramanız yeterli olacaktır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Araç Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Generali Sigorta sizin aracınızın da maruz kalacağı tüm hasarları teminat altına almaktadır.',
          subList: null
        },
        {
          paragraph:
            "%70'e varan hasarsızlık indirimi ve belirli meslek gruplarına %10 ek indirim ile primlerinizi minimuma indirme şansınız bulunur.",
          subList: null
        },
        {
          paragraph:
            'Generali Sigorta Benim Kaskom Poliçesi, Genişletilmiş Kasko teminatları aşağıdaki gibidir;',
          subList: [
            'Çarpma, çarpışma, devrilme, yanma',
            'Çalınma',
            'Yetkili olmayan kişilerce çekilme',
            'GLHH, terör ve üçüncü kişilerin kötü niyetli hareketleri',
            'Deprem, fırtına, dolu, yıldırım, toprak kayması ve yanardağ püskürmesi',
            'Sel, su baskını',
            'Sigara ve benzeri zararlar',
            'Anahtar kaybı, kilit mekanizma değişikliği',
            'Kemirgen hayvan zararları',
            'Yanlış akaryakıt dolumu',
            'Özel eşya teminatı',
            'İMM teminatı',
            'Ferdi kaza teminatı',
            'Mini onarım hizmeti.'
          ]
        },
        {
          paragraph:
            'Tüm teminatlar Genişletilmiş Kasko teminatları kapsamındadır. Cebinizden ekstra bir ücret ödemeden poliçe kapsamında tüm zararlarınızı karşılatabilir, ağır hasar olması durumunda aracınızın piyasa bedelini geri alabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Generali Sigorta DASK, zorunlu deprem sigortası ile depremin neden olabileceği maddi zararları ve deprem sonucunda meydana gelen yangın, infilak, yer kayması ve tsunami gibi hasarlara karşı evinizi güvenceye alır. ',
          subList: null
        },
        {
          paragraph:
            'Taksitli ve peşin ödeme imkanı ve yenilemelerde indirim fırsatı ile sizlere avantaj sağlar.',
          subList: null
        },
        {
          paragraph:
            'Zorunlu deprem sigortası hesaplamalarında poliçe primini konutların yapı tarzı ve hangi deprem risk bölgelerine bulunduklarına göre tespit edilmektedir. Hasarsız geçen her yılsonunda yenilenen poliçeden %5, %10 ,%20 indirim kazanılmaktadır. Üç yıl üst üste aralıksız yenilenmesi durumunda % 20’ye ulaşır ve en üst indirim basamağıdır. Hasar durumunda sigortalının alacağı sigorta bedeli, her yıl Hazine Müsteşarlığı tarafından belirlenen metrekare başına düşen inşa bedeli ile hesaplanır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Konut Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Generali Sigorta Konut Sigortasından kiracı ve mal sahipleri faydalanabilir. Generali Sigorta Konut Sigortası ile evinizin içindeki eşyalarınızı, kasanızı, konutunuzun yer aldığı binanın alabileceği hasarları teminat altına almış olursunuz. ',
          subList: null
        },
        {
          paragraph:
            'Konut sigortasında dikkat edilmesi gereken önemli adım bulunduğunuz konumda oluşabilecek tüm riskleri teminat olarak poliçenize ekletmiş olmanızdır.  ',
          subList: null
        },
        {
          paragraph:
            'Konut sigortasında dikkat edilmesi gereken önemli adım bulunduğunuz konumda oluşabilecek tüm riskleri teminat olarak poliçenize ekletmiş olmanızdır.  ',
          subList: null
        },
        {
          paragraph:
            'Konut sigortası hesaplamalarında; Bina Yaşı, Yapı Tipi, Binada Bulunan Toplam Kat Sayısı / Konutun Bulunduğu Kat, Yüz Ölçümü, Merdiven Dairesi Yüz Ölçümü, Dış Cephe Çeşidi, Tapudaki Pafta, Parsel Bilgisi yeterlidir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta İşyeri Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Generali Sigorta ile işyerinizi de güvence altına alabilirsiniz. Gelir kaynağınızı teminat altına alıp sonrasında oluşabilecek maddi ve manevi tüm zararlardan korunabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'İşyeri sigortası; işyerinizi veya işyerinizdeki aklınıza gelebilecek her türlü demirbaş eşya, emtia, makine, tesisat gibi varlıklarınızın alabileceği her türlü zarar, yangın, hırsızlık, deprem, sel-su baskını gibi tüm doğal afetlerden kaynaklı, iş durması, çalışamama, hizmete ara verilmesi, kira kaybı, sorumlu olunan kişilere karşı ve daha birçok riske karşı güvence sağlayan en az zararla sizi teminat altında tutan sigorta türüdür.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Ferdi Kaza Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Generali Ferdi Kaza Sigortası kapsamında, kazadan kaynaklı vefat ve kazadan kaynaklı maluliyet risklerine karşı hayat kalitenizi koruma altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Hayati risklere karşı ekstra planınızı oluşturmanız sizin içinde en güvenli yol.',
          subList: null
        },
        {
          paragraph: 'Generali Ferdi Kaza Sigortası Teminatları:',
          subList: [
            'Kaza Sonucu Vefat',
            'Kaza Sonucu Sürekli Sakatlık',
            'Kişi Aile Hukuksal Koruma',
            'Generali Yardım (365 gün 7/24 acil hizmet).'
          ]
        },
        {
          paragraph:
            'Beklenmedik risklere karşı güvence sağlayan ferdi kaza planını satın alarak, körü sürprizlere hazırlıklı olabilirsiniz. Generali Sigorta güvencesinde olmak isteyen adaylar <strong><em><u>alokasko.com</u></em></strong> üzerinden fiyat teklifi alarak avantajlı fiyatlardan yararlanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Nakliyat Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Yurtiçi ya da uluslararası emtia nakliyatında oluşabilecek nakliyat hasarlarını Generali Sigorta ile güvence altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Kara, hava, deniz veya demiryolu taşımaları sırasında ortaya çıkabilecek ve Nakliyat Emtia Sigorta Poliçesi ile teminat altına alınan bazı riskler: ',
          subList: null
        },
        {
          paragraph:
            'Nakliyat Sigortası ürününden faydalanmak için <strong><em><u>alokasko.com</u></em></strong> uzman sigorta danışanlarına ulaşabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Vize alma işlemleriniz sırasında yapılması zorunlu olan seyahat sağlık sigortanızı Generali Sigorta kapsamında yaptırabilirsiniz. Tercih edeceğiniz seyahat sağlık sigortası poliçesi ABD seyahatlerinizde ve Schengen vizesi kapsamında geçerlidir.',
          subList: null
        },
        {
          paragraph:
            '<strong>Generali Sigorta Seyahat Sağlık Sigortası Teminatları: </strong>',
          subList: [
            'Ayakta, Yatarak (Hastanede) Tıbbi Tedavi ',
            'Cenaze Nakli ',
            'Sigortalının Tıbbi Nedenlerle Nakli veya Seyahati',
            'Tıbbi Bilgi ve Danışma',
            'Refakatçi Nakli',
            'Gerekli İlaçların Sevki',
            'Acil Mesajların İletilmesi',
            'Tıbbi Seyahat Bilgi Hattı.'
          ]
        },
        {
          paragraph:
            '30.000 Euro kapsamlı seyahat sağlık sigortası satın almak için <strong><em><u>teklif al formunu</u></em></strong> doldurmanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Poliçe Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Generali Sigorta poliçe sorgulaması yapmak için sigorta şirketinin resmi web site adresini ziyaret ederek, “Generali Hesabım” sayfasına giriş yapmanız gerekmektedir. Bu sayfada sizden T.C. Kimlik Numaranız talep edilmektedir. ',
          subList: null
        },
        {
          paragraph: 'Generali Hesabınıza Giriş Yaparak:',
          subList: [
            'Poliçe Bilgileri ',
            'Hasar Takibi ',
            'Kişisel Ayarlar ',
            'İletişim Formu Adımlarına Ulaşabilirsiniz.'
          ]
        }
      ]
    },
    {
      title: 'Generali Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Hasar sorgulaması yapmak isteyen sigortalılar Generali Sigorta’nın resmi web site adresini ziyaret etmelidir.',
          subList: null
        },
        {
          paragraph:
            'Sigorta poliçenizi <strong><em><u>alokasko.com</u></em></strong> üzerinden satın aldıysanız, tüm hasar işlemlerinizi sigorta danışmanınız takip eder.',
          subList: null
        }
      ]
    },
    {
      title: 'Generali Sigorta Poliçe Fiyatı Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Generali Sigorta’dan talep edeceğiniz tüm sigorta branşlarına özel indirimli fiyatları tek tuşla <strong><em><u>alokasko.com</u></em></strong> üzerinden alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Teklif al formunu doldurmanız sonucunda fiyat karşılaştırması yapabilir ve size özel atanan sigorta uzmanı ile görüşme sağlayarak en doğru poliçeyi tercih edebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
